
module.exports = function getResource(label) {
    const resources = {
        color: 'Couleur',
        size: 'Format',
        edit: 'Modifier',
        doNotSubstitute: 'Do not substitute',
        substituteWith: 'Substitut with: '
    };

    return resources[label];
};
